import React from 'react'
import classes from '../styles.module.scss'
import Button from '@material-ui/core/Button'
import { DownloadButton } from '../../../../uiKit/icons/Icons'
import { alertError, alertSuccess, createJsonHeaders } from '../../../../api'
import {BASE_URL} from '../../../../configs'

interface GeneratingContactsFeedbacksButtonExcelProps {
  botId: number
}

export const GeneratingContactsFeedbacksButtonExcel: React.FC<GeneratingContactsFeedbacksButtonExcelProps> = ({ botId }) => {
  const onClickHandler = () => {
    return fetch(`${BASE_URL}/bot/${botId}/contacts/feedbacks`, {
      credentials: 'include',
      headers: createJsonHeaders(),
      method: 'POST',
    })
      .then(res => res.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'Contacts_Feedbacks.xlsx'
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        alertSuccess('Feedbacks downloaded successfully!')
      })
      .catch(() => {
        alertError('Sorry but something going wrong at downloading feedbacks, please ping support!')
      })
  }

  return (
    <>
      <Button className={classes.generateFeedbacksButton} onClick={onClickHandler} variant="raised">
        <DownloadButton height="13px" width="13px" color="#FFFFFF" />
      </Button>
      <p className={classes.downloadFeedbacksTitle}>Download feedbacks</p>
    </>
  )
}
